import { ApolloClient } from '@apollo/client';
import { getDealById } from '../../../api/queries';
import { getDocumentById } from '../../../api/queries_v2';
import { graphql } from '../../../gql';

type ResponsePayloadType = {
  success: boolean;
};

type Props = {
  documentId: string;
  dealId: string | number;
  teamId: string;
  threshold: string;
  userIds: string[];
  permitEditingDuringApproval?: boolean;
  additionalMessage?: string | null;
  useApprovalOrder?: boolean;
  approvalOrderUserIds?: string[] | null;
};

export function createDocumentApprovalRequest({
  documentId,
  threshold,
  userIds,
  dealId,
  teamId,
  permitEditingDuringApproval,
  additionalMessage,
  useApprovalOrder,
  approvalOrderUserIds,
}: Props) {
  return function (client: ApolloClient<object>): Promise<ResponsePayloadType> {
    const variables = {
      documentId,
      threshold,
      userIds,
      teamId,
      confirm: true,
      permitEditingDuringApproval,
      additionalMessage,
      useApprovalOrder,
      approvalOrderUserIds,
    };

    const mutation = graphql(/* GraphQL */ `
      mutation createDocumentApprovalRequest(
        $documentId: ID!
        $threshold: String!
        $userIds: [ID!]!
        $teamId: ID!
        $confirm: Boolean
        $permitEditingDuringApproval: Boolean
        $additionalMessage: String
        $useApprovalOrder: Boolean
        $approvalOrderUserIds: [ID!]
      ) {
        createDocumentApprovalRequest(
          documentId: $documentId
          threshold: $threshold
          userIds: $userIds
          teamId: $teamId
          confirm: $confirm
          permitEditingDuringApproval: $permitEditingDuringApproval
          additionalMessage: $additionalMessage
          useApprovalOrder: $useApprovalOrder
          approvalOrderUserIds: $approvalOrderUserIds
        ) {
          document {
            id
          }
        }
      }
    `);

    const refetchQueries = [
      {
        query: getDealById,
        variables: {
          dealId,
        },
      },
      {
        query: getDocumentById,
        variables: {
          documentId,
        },
      },
    ];

    return client
      .mutate({ mutation: mutation as any, variables, refetchQueries })
      .then(({ data }: Record<any, any>) => data.createDocumentApprovalRequest);
  };
}
